import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { SelectList } from "@common/selectList";
import { ArrowIcon } from "@common/assets/arrowIcon";
import { SortOptions } from "../../types";
import { Props } from "./types";
import styles from "./styles.scss";

function Sort({ sort, setSort }: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.sort}>
      <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
        {({ isOpen }) => ({
          input: (
            <div
              className={classNames(styles.input, { [styles.opened]: isOpen })}
            >
              <p>{t(sort)}</p>
              <ArrowIcon className={styles.icon} />
            </div>
          ),
          list: (
            <div className={styles.list}>
              {Object.values(SortOptions).map((option) => (
                <div
                  key={option}
                  className={classNames(styles.item, {
                    [styles.selected]: option === sort,
                  })}
                  onClick={() => setSort(option)}
                >
                  <p>{t(option)}</p>
                </div>
              ))}
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { Sort };
